<script setup lang="ts">
import { urlFilters } from '@/composables/urlFilters';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import styles from '@/assets/sass/components/company-filter.module.scss';
import { find } from 'lodash-es';
import Multiselect from 'vue-multiselect';

const { filters, updateFilters } = urlFilters();
const { t } = useI18n();

interface CompanyOption {
    code: 'costa' | 'msc';
    label: string;
}

const companies: CompanyOption[] = [
    {
        code: 'costa',
        label: t('LABELS.costa-cruises')
    },
    {
        code: 'msc',
        label: t('LABELS.msc-cruises')
    }
];

const selectedCompany = computed<CompanyOption | null>({
    get() {
        return find(companies, (o) => o.code === filters.companyCode) || null;
    },

    set(newSelection) {
        updateFilters({ companyCode: newSelection?.code || null });
    }
});

</script>
<template>
    <Multiselect :class="styles.multiselect" v-model="selectedCompany" :options="companies" :multiple="false"
        track-by="code" :custom-label="(o: CompanyOption) => o.label" :select-label="t('MULTISELECT.selectLabel')"
        :selected-label="t('MULTISELECT.selectedLabel')" :deselect-label="t('MULTISELECT.deselectLabel')"
        :placeholder="t('LABELS.anywhere')" :close-on-select="false" :searchable="false">
        <template #noResult>
            {{ t('MULTISELECT.noResult') }}
        </template>
        <template #noOptions>
            {{ t('MULTISELECT.noOptions') }}
        </template>
    </Multiselect>
</template>
